var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SystemModel, SystemsClient, CompaniesClient, SitesClient, GetSiteListQuery, SiteModel, RegisterSystemCommand, CreateSystemCommandModel, ComponentModel } from "@/app/api/battery-portal-api";
import { Component, Vue, Watch } from "vue-facing-decorator";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import { DownloadUtil } from "@/app/utils/download-util";
const systemClient = new SystemsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let SystemRegistrationVue = class SystemRegistrationVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.systemId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        // components
        this.msg = new Alert();
        // models
        this.system = new SystemModel();
        this.systemSite = new SiteModel();
        this.registeredComponent = new ComponentModel();
        // arrays
        this.companies = [];
        this.sites = [];
    }
    created() {
        let system = new SystemModel();
        system.init({});
        this.map(system);
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // get
    getLookups() {
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                this.companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || "",
                        parentKey: item.countryId
                    };
                });
                this.companies.unshift({ value: null, text: TextHelper.emptyListItemName });
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.loaded = true;
                let companyId = parseInt(this.$route.params.companyId) || 0;
                if (!companyId || !this.isNewSystem)
                    return;
                let idx = ArrayHelper.findFirstIndex(this.companies, (item) => {
                    return companyId == item.value;
                });
                if (idx < 0)
                    return;
                this.system.companyId = companyId;
            })
        ];
        Promise.all(promises);
    }
    ;
    getSites() {
        let companyId = this.system.companyId;
        if (!companyId) {
            this.sites = new Array();
            return;
        }
        ;
        let query = new GetSiteListQuery({ companyId: companyId, includeDeleted: false });
        siteClient
            .getList(query)
            .then(response => {
            this.sites = (response || []).map((item) => {
                return {
                    value: item.siteId,
                    text: item.siteName || ""
                };
            });
            this.sites.unshift({ value: null, text: TextHelper.emptyListItemName });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    map(system) {
        this.system = system;
        this.loaded = true;
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        this.attemptedSave = true;
        this.msg.clear();
        if (!this.companyId) {
            Notifier.onError("Please select a company.");
            return;
        }
        ;
        if (!this.siteId) {
            Notifier.onError("Please select an installation site.");
            return;
        }
        ;
        this.working = true;
        systemClient
            .register(new RegisterSystemCommand({
            requestModel: new CreateSystemCommandModel({
                system: this.system,
                createController: true
            })
        }))
            .then(response => {
            if (!response.success) {
                let errors = response.errors || [];
                if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
                    let error = errors[0];
                    this.msg.warn(error);
                    Notifier.onError(error);
                    return;
                }
            }
            if (!response.component)
                return;
            this.registeredComponent = response.component;
            if (!response.system)
                return;
            this.system = response.system;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    copyToClipboard() {
        var _a;
        try {
            const element = document.getElementById("config");
            element.select();
            document.execCommand("copy");
            if (window.getSelection)
                (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
            Notifier.onOk("Copied");
        }
        catch (ex) {
            Notifier.onError("Looks like your web browser does not allow us access to clipboard. Please copy the configuration manually or save to file instead.");
        }
    }
    ;
    downloadFile() {
        if (!this.registrationResult) {
            Notifier.onError(`Please register a system first.`);
            return;
        }
        let fileName = `registration.${this.registeredComponent.registrationKey}.txt`;
        let blob = new Blob([this.registrationResult], {
            type: "text/plain;charset=utf-8"
        });
        DownloadUtil.downloadFile(blob, fileName);
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    get pageTitle() {
        return this.isNewSystem ? "Register System" : this.systemTitle;
    }
    ;
    get systemTitle() {
        if (!this.system)
            return "";
        return this.system.systemName;
    }
    ;
    get isNewSystem() {
        return !this.systemId;
    }
    ;
    get companyId() {
        return this.system.companyId;
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return (item.value == this.system.companyId);
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.system.companyId = item.value;
    }
    ;
    get siteId() {
        return this.system.siteId;
    }
    ;
    get site() {
        return this.sites.filter(item => {
            return item.value == this.system.siteId;
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.system.siteId = item.value;
    }
    ;
    get siteSelected() {
        return this.site && this.site.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get registered() {
        return this.registeredComponent && this.registeredComponent.componentId ? true : false;
    }
    ;
    get registrationResult() {
        if (!this.registeredComponent)
            return null;
        return JSON.stringify({
            registrationKey: this.registeredComponent.registrationKey,
            componentId: this.registeredComponent.componentId,
            componentCode: this.registeredComponent.componentCode,
            componentName: this.registeredComponent.componentName,
            whenCreated: this.registeredComponent.whenCreated
        });
    }
};
__decorate([
    Watch("system.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemRegistrationVue.prototype, "getSites", null);
SystemRegistrationVue = __decorate([
    Component({
        name: "SystemRegistrationVue"
    })
], SystemRegistrationVue);
export default SystemRegistrationVue;
